import { FunctionComponent, useContext, useEffect, useState } from 'react';
import { useTrackingCode } from 'react-hubspot-tracking-code-hook';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../../contexts/AppContext';

export const Hubspot: FunctionComponent = () => {
  const [loaded, setLoaded] = useState(false);
  const { UserStore } = useContext(AppContext);
  const { setPathPageView, setIdentity } = useTrackingCode();
  const location = useLocation();

  useEffect(() => {
    let script: HTMLScriptElement;

    if (document) {
      script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = '//js-eu1.hs-scripts.com/144655472.js';
      script.id = 'hs-script-loader';
      document.body.appendChild(script);

      script.onload = function () {
        setLoaded(true);
      };
    }

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (loaded && UserStore.isAuthenticated && UserStore.user) {
      setIdentity(UserStore.user.email);
    }
  }, [loaded, UserStore.isAuthenticated]);

  useEffect(() => {
    if (loaded) {
      setPathPageView(location.pathname);
    }
  }, [loaded, location.pathname]);

  return null;
};
